module.exports = __webpack_public_path__ + "static/megaphone-f6dfb74c936090e31147e249de78c0f5.svg";